import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CartLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";

export interface OrderLinePartNumbersDisplay {
    isCmiProduct: boolean;
    customerProductNumber?: string;
    iewcPartNumber?: string;
    manufacturerItem?: string;
}

export interface SetAddedToCartModalParameter {
    isOpen: boolean;
    cartLine?: CartLineModel;
    originalQtyOrdered?: number;
    existingQtyOrdered?: number;
    isBulkAdd?: boolean;
    bulkProductCount?: number;
    isQtyAdjusted?: boolean;
    product?: ProductModel;
    productInfo?: ProductInfo;
    hasSpoolProducts?: boolean;
    spoolNoticeId?: string;
    hideViewCartButton?: boolean;
    /** When true, AddedToCartModal always treats the line as quote-required (e.g. Request a Quote from qty validation). */
    forceQuoteRequired?: boolean;
    /** When set, AddedToCartModal shows OrderLinesList part numbers instead of catalog ProductPartNumbers. */
    orderLinePartNumbers?: OrderLinePartNumbersDisplay;
}

type HandlerType = Handler<SetAddedToCartModalParameter>;

export const DispatchSetAddedToCartModalOpen: HandlerType = props => {
    props.dispatch({
        type: "Custom/SetAddedToCartModal/Complete",
        isOpen: props.parameter.isOpen,
        cartLine: props.parameter.cartLine,
        originalQtyOrdered: props.parameter.originalQtyOrdered,
        existingQtyOrdered: props.parameter.existingQtyOrdered,
        isBulkAdd: props.parameter.isBulkAdd,
        bulkProductCount: props.parameter.bulkProductCount,
        isQtyAdjusted: props.parameter.isQtyAdjusted,
        product: props.parameter.product,
        productInfo: props.parameter.productInfo,
        hasSpoolProducts: props.parameter.hasSpoolProducts,
        spoolNoticeId: props.parameter.spoolNoticeId,
        hideViewCartButton: props.parameter.hideViewCartButton,
        forceQuoteRequired: props.parameter.forceQuoteRequired,
        orderLinePartNumbers: props.parameter.orderLinePartNumbers,
    } as any);
};

export const chain = [DispatchSetAddedToCartModalOpen];

const setAddedToCartModalOpen = createHandlerChainRunner(chain, "SetAddedToCartModalOpen");
export default setAddedToCartModalOpen;
